export class Imagen {

    public id : number;
    public base64:string;
    public descripcion:string;
    public codigoDocumento:string;
    public tipoDocumento:string;

}





// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/imagen.ts